function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable @typescript-eslint/ban-types */
// typed-ember has not publihsed types for this yet
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { getValue } from '@glimmer/tracking/primitives/cache';
import { assert } from '@ember/debug'; // typed-ember has not publihsed types for this yet
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

import { invokeHelper } from '@ember/helper';
import { FUNCTION_TO_RUN, FunctionRunner, INITIAL_VALUE } from './resources/function-runner';
import { DEFAULT_THUNK, normalizeThunk, proxyClass } from './utils';
export function useFunction(...passedArgs) {
  let [context] = passedArgs;
  let initialValue;
  let fn;
  let thunk;
  assert(`Expected second argument to useFunction to either be an initialValue or the function to run`, passedArgs[1] !== undefined);

  if (isVanillaArgs(passedArgs)) {
    fn = passedArgs[1];
    thunk = passedArgs[2];
  } else {
    initialValue = passedArgs[1];
    fn = passedArgs[2];
    thunk = passedArgs[3];
  }

  let target = buildUnproxiedFunctionResource(context, initialValue, fn, thunk || DEFAULT_THUNK); // :(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  return proxyClass(target);
}

function isVanillaArgs(args) {
  return typeof args[1] === 'function';
}

const FUNCTION_CACHE = new WeakMap();
/**
 * The function is wrapped in a bespoke resource per-function definition
 * because passing a vanilla function to invokeHelper would trigger a
 * different HelperManager, which we want to work a bit differently.
 * See:
 *  - function HelperManager in ember-could-get-used-to-this
 *  - Default Managers RFC
 *
 */

function buildUnproxiedFunctionResource(context, initial, fn, thunk) {
  let resource;
  let klass;
  let existing = FUNCTION_CACHE.get(fn);

  if (existing) {
    klass = existing;
  } else {
    klass = class AnonymousFunctionRunner extends FunctionRunner {
      constructor(...args) {
        super(...args);

        _defineProperty(this, INITIAL_VALUE, initial);

        _defineProperty(this, FUNCTION_TO_RUN, fn);
      }

    };
    FUNCTION_CACHE.set(fn, klass);
  }

  return {
    get value() {
      if (!resource) {
        resource = invokeHelper(context, klass, () => {
          return normalizeThunk(thunk);
        });
      }

      return getValue(resource);
    }

  };
}